/**
 * 404 Not Found Page
 * Displayed when user navigates to an unknown URL
 */
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'

export function NotFoundPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="text-center">
        <h1 className="text-2xl sm:text-4xl font-bold text-gray-900 mb-2">
          Страница не найдена
        </h1>
        <p className="text-gray-500 mb-4 sm:mb-6">
          Запрашиваемая страница не существует
        </p>
        <Link to="/">
          <Button>На главную</Button>
        </Link>
      </div>
    </div>
  )
}
